/**
 * Envia al cliente a la pagina de seguimiento del courier.
 *
 * El codigo viaja como segmento de path, no como query param, asi que un `<form method="get">`
 * nativo no puede armar la URL solo. El patron llega por `data-tracking-url`, con el token
 * `[codigo]` donde va el valor escrito. Abre en una pestana nueva para no perder la tienda.
 */
document.querySelectorAll('form[data-order-tracking]').forEach((form) => {
  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const input = form.querySelector('[data-order-tracking-input]');
    const code = input.value.trim();

    // Vaciar el campo hace que `required` dispare el aviso nativo, en el idioma del navegador.
    if (!code) {
      input.value = '';
      input.reportValidity();
      return;
    }

    window.open(form.dataset.trackingUrl.replace('[codigo]', encodeURIComponent(code)), '_blank', 'noopener');
  });
});
